import BUY from '~/shared/legacy_res/img/svg/pendingScreen/buy.svg';
import EXCHANGE from '~/shared/legacy_res/img/svg/pendingScreen/exchange.svg';
import SELL from '~/shared/legacy_res/img/svg/pendingScreen/sell.svg';
import {default as RECEIVE, default as TOPUP} from '~/shared/legacy_res/img/svg/pendingScreen/topup.svg';
import WITHDRAW from '~/shared/legacy_res/img/svg/pendingScreen/withdraw.svg';
import SEND from '~/shared/legacy_res/img/svg/pendingScreen/send.svg';

export const PENDING_TRANS_IMG: Record<string, string> = {
    SEND,
    BUY,
    'TOP UP': TOPUP,
    WITHDRAW,
    EXCHANGE,
    SELL,
    RECEIVE,
};
